import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-info-container" }
const _hoisted_2 = { class: "profile-header" }
const _hoisted_3 = { class: "user-name" }
const _hoisted_4 = { class: "user-role" }
const _hoisted_5 = { class: "cards-container" }
const _hoisted_6 = { class: "profile-card card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = {
  key: 0,
  class: "profile-card card"
}
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "info-value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "info-value" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-value" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = { class: "info-item" }
const _hoisted_27 = { class: "info-value" }
const _hoisted_28 = { class: "info-item" }
const _hoisted_29 = {
  key: 1,
  class: "profile-card card"
}
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "actions" }

import { ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { EditOutlined, SwapOutlined, UserAddOutlined } from '@ant-design/icons-vue';
import { useUserStore } from '@/store';
import { putUserBindStatus, putUserDetailApi } from '@/servers/api/user';
import { getSchoolApi } from '@/servers/api/school';
import { getClassesApi, getClassesDetailApi } from '@/servers/api/classes';
import { getStudentApi } from '@/servers/api/student';
import { useLogout } from '@/composables/useLogout';

// 定义响应式变量

export default /*@__PURE__*/_defineComponent({
  __name: 'MyInfo',
  setup(__props) {

const schoolList = ref<any[]>([]);
const classList = ref<any[]>([]);
const studentList = ref<any[]>([]);
const open = ref<boolean>(false);
const bindOpen = ref<boolean>(false);
const email = ref('');
const phone = ref('');
const name = ref('');
const inputStuName = ref('');
const classId = ref<number | undefined>(undefined);
const selectedStudent = ref<any>(null);
const confirmLoading = ref<boolean>(false);
const bindConfirmLoading = ref<boolean>(false);

// 获取用户信息
const userStore = useUserStore();
const userData = userStore.userInfo;

const showModifyModal = () => {
  open.value = true;
  email.value = userData.email ?? '';
  phone.value = userData.phone ?? '';
};

const showBindModal = () => {
  bindOpen.value = true;
  name.value = userData.name ?? '';
  email.value = userData.email ?? '';
  resetBindForm();
};

const resetBindForm = () => {
  inputStuName.value = '';
  classList.value = [];
  classId.value = undefined;
  selectedStudent.value = null;
};

const handleOk1 = () => {
  confirmLoading.value = true;
  const params = { user_id: String(userData.id) };
  const userInfo = {
    phone: phone.value,
    email: email.value,
    name: userData.name,
    password: userData.password
  };

  const { logout } = useLogout();

  putUserDetailApi(params, userInfo).then((res: any) => {
    console.log(res);
    message.success('修改成功,请重新登录');
    setTimeout(() => {
      logout();
    }, 1500);
  }).finally(() => {
    confirmLoading.value = false;
    open.value = false;
  });
};

const handleOk2 = () => {
  if (!classId.value) {
    message.warning('请选择班级');
    return;
  }

  if (!selectedStudent.value) {
    message.warning('未找到学生信息');
    return;
  }

  bindConfirmLoading.value = true;
  const params = {
    id: String(userData.id),
    school: String(selectedStudent.value.school_name || selectedStudent.value.school),
    class_id: String(classId.value),
    stuName: String(selectedStudent.value.name)
  };

  const { logout } = useLogout();
  putUserBindStatus(params).then((res: any) => {
    if (res.code === 200) {
      message.success('绑定成功');
      setTimeout(() => {
        logout();
      }, 1500);
    } else {
      message.error('绑定失败');
    }
  }).finally(() => {
    bindConfirmLoading.value = false;
  });
};

const onSearchStudent = async (value: string) => {
  if (!value.trim()) {
    message.warning('请输入学生姓名');
    return;
  }

  try {
    const res = await getStudentApi({ name: value, size: 100 });
    if (res.code === 200) {
      if (res.data && res.data.length > 0) {
        studentList.value = res.data;
        await getClassListByStudents(res.data);
        
      } else {
        message.info('未找到该学生');
        classList.value = [];
        classId.value = undefined;
        selectedStudent.value = null;
      }
    } else {
      message.error(res.message || '查询学生信息失败');
    }
  } catch (error) {
    message.error('查询学生信息异常');
    console.error(error);
  }
};

const getClassListByStudents = async (students: any[]) => {
  try {
    classList.value = [];
    classId.value = undefined;
    selectedStudent.value = null;
    console.log('Getting class list for students:', students);
    // 获取所有涉及到的班级ID
    const classIds = Array.from(new Set(students.map(s => s.class_id)));

    // 获取每个班级的信息
    const classInfoMap: Record<number, any> = {};
    
    // 并行获取所有班级详情
    const classPromises = classIds.map(classId => 
      getClassesDetailApi({ class_id: classId }).catch(() => null)
    );
    
    const classResults = await Promise.all(classPromises);
    
    console.log('classResults:', classResults);
    classResults.forEach(result => {
      if (result && result.code === 200 && result.data) {
        classInfoMap[result.data[0].id] = result.data[0];
      }
    });
    console.log('classInfoMap:', classInfoMap);
    // 构建最终的班级列表
    const finalClassList: any[] = [];
    students.forEach(student => {
      const classInfo = classInfoMap[student.class_id];
      if (classInfo) {
        finalClassList.push({
          id: student.class_id,
          name: classInfo.name,
          school_name: student.school_name || student.school
        });
      }
    });

    classList.value = finalClassList;

    // 如果有班级列表，自动选中第一个
    if (finalClassList.length > 0) {
      classId.value = finalClassList[0].id;
      // 手动触发班级选择变化，设置选中的学生
      onClassChange(finalClassList[0].id);
    }
  } catch (error) {
    message.error('获取班级信息异常');
    console.error(error);
  }
};

// 当班级选择变化时的处理函数
const onClassChange = (value: number) => {
  classId.value = value;
  // 查找选中的学生
  const matchedStudent = studentList.value.find(s => s.class_id === value);
  if (matchedStudent) {
    selectedStudent.value = matchedStudent;
  }
};

// 监听班级选择变化
watch(classId, (newVal) => {
  if (newVal) {
    onClassChange(newVal);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(userData).name) + " 的个人中心", 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userData)?.student ? '学生用户' : '教师用户'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("span", { class: "card-title" }, "基本信息")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: showModifyModal
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(EditOutlined)),
                _cache[8] || (_cache[8] = _createTextVNode(" 编辑信息 ", -1))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_row, { gutter: [24, 24] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info-label" }, "用户姓名：", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(userData).name), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "info-label" }, "登录手机号：", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(userData).email), 1)
                  ])
                ]),
                _: 1
              }),
              (_unref(userData).phone)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info-label" }, "联系方式：", -1)),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(userData).phone), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(userData)?.student)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", { class: "card-title" }, "学生信息")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  onClick: showBindModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SwapOutlined)),
                    _cache[13] || (_cache[13] = _createTextVNode(" 更换绑定 ", -1))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_row, { gutter: [24, 24] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "info-label" }, "学生姓名：", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(userData)?.student?.name), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "info-label" }, "学校：", -1)),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(userData)?.student?.school), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "info-label" }, "班级编号：", -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(userData)?.student?.class_id), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "info-label" }, "年级：", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(userData)?.student?.grade), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "info-label" }, "选科情况：", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(userData)?.student?.subject_selection), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "info-label" }, "是否在读：", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["info-value", {'status-active': _unref(userData)?.student?.state == 1}])
                        }, _toDisplayString(_unref(userData)?.student?.state == 1 ? '在读' : '不在读'), 3)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("span", { class: "card-title" }, "绑定学生信息")
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: showBindModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UserAddOutlined)),
                    _cache[21] || (_cache[21] = _createTextVNode(" 绑定学生 ", -1))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_empty, { description: "暂未绑定学生信息" })
            ])
          ]))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        open: open.value,
        "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
        title: "修改信息",
        onOk: handleOk1,
        "confirm-loading": confirmLoading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "个人邮箱" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: email.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    placeholder: "请输入个人邮箱"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "联系方式" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: phone.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((phone).value = $event)),
                    placeholder: "请输入联系方式"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open", "confirm-loading"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        open: bindOpen.value,
        "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((bindOpen).value = $event)),
        title: "绑定学生信息",
        onOk: handleOk2,
        "confirm-loading": bindConfirmLoading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "昵称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: name.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((name).value = $event)),
                    placeholder: "",
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "邮箱" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: email.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event)),
                    placeholder: "",
                    disabled: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "学生姓名" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_search, {
                    value: inputStuName.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((inputStuName).value = $event)),
                    placeholder: "请输入学生姓名",
                    "enter-button": "搜索",
                    onSearch: onSearchStudent
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (classList.value.length > 0)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    label: "所在班级"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: classId.value,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((classId).value = $event)),
                        style: {"width":"100%"},
                        placeholder: "请选择班级",
                        options: classList.value.map(cls => ({ label: `${cls.name} (${cls.school_name})`, value: cls.id }))
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (selectedStudent.value)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 1,
                    label: "确认学生"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions, {
                        size: "small",
                        column: 1
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "学生姓名" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedStudent.value.name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "学校" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedStudent.value.school_name || selectedStudent.value.school), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "年级" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(selectedStudent.value.grade), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open", "confirm-loading"])
    ])
  ]))
}
}

})